// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"332":"99286334","633":"be7bb98b"}[chunkId] + ".chunk.js";
};